import { Menu } from 'lucide-react'
import LanguageSwitcher from './LanguageSwitcher'

export default function Header({ onMenuClick }) {
  return (
    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      <button
        type="button"
        className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
        onClick={onMenuClick}
      >
        <Menu className="h-6 w-6" />
      </button>

      <div className="flex flex-1 justify-end">
        <LanguageSwitcher />
      </div>
    </div>
  )
}
